import React, { useEffect, useState } from "react";
import ModelLoading from "../../utils/ModelLoading";
import {
   isFaceDetectionModelLoaded,
   isFacialLandmarkDetectionModelLoaded,
   isFeatureExtractionModelLoaded,
   loadModels,
} from "../../faceUtil";


export default ({ setIsFaceAPIModelsLoaded }) => {
   const [isAllModelLoaded, setIsAllModelLoaded] = useState(false);
   const [loadingMessage, setLoadingMessage] = useState("");
   const [loadingMessageError, setLoadingMessageError] = useState("");



   useEffect(() => {
      async function loadingTheModel() {
         await loadModels(setLoadingMessage, setLoadingMessageError);
         setIsAllModelLoaded(true);
         setIsFaceAPIModelsLoaded(true)
      }
      if (
         !!isFaceDetectionModelLoaded() &&
         !!isFacialLandmarkDetectionModelLoaded() &&
         !!isFeatureExtractionModelLoaded()) {
         setIsAllModelLoaded(true);
         setIsFaceAPIModelsLoaded(true)
         return;
      }
      loadingTheModel();
   }, [isAllModelLoaded]);

   return (
      <>
         <div className="scan-face-sub-header">
            {!isAllModelLoaded ? (
               <>
                  <ModelLoading loadingMessage={loadingMessage} />
               </>
            ) : loadingMessageError ? (
               <div className="error">{loadingMessageError}</div>
            ) : (
               isAllModelLoaded &&
               loadingMessageError.length === 0 && (
                  <>
                     <h6>Face Scan Attendance Online</h6>
                  </>
               )
            )
            }
         </div>

      </>
   );
};
